import { Skeleton } from '@mui/material';
import { useGetTablesList } from '../api/dataCatalog/getAllTables';
import { useEffect, useState } from 'react';
import ToolTip from '@/components/Tooltip';
import { CaretRight } from '@phosphor-icons/react';
import { uniqBy } from 'lodash';

export const SourcesModalTableList = ({
  sourceId,
  tableId,
  setTableId,
  tableRefetch,
  setTableRefetch,
  tables,
  // searchQuery,
  setTables,
  tablesLoading,
  setTablesLoading,
  integrationsLoading,
  setCurrentColPageNumber,
  tooltipShow,
  setTooltipShow,
}) => {
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  const tablesListData = useGetTablesList({
    // keyword: searchQuery,
    // columnNameKeyword: searchQuery,
    integrationId: sourceId.id,
    pageNumber: currentPageNumber,
    config: {
      staleTime: Infinity,
      // enabled: currentPageNumber === 1 || currentPageNumber <= totalPages,
    },
  });

  useEffect(() => {
    if (tableRefetch) {
      setCurrentPageNumber((prev) => prev + 1);
    }
  }, [tableRefetch]);

  useEffect(() => {
    setTables([]);
    setCurrentPageNumber(1);
  }, [sourceId.id]);

  // useEffect(() => {
  //   setTables([]);
  //   setCurrentPageNumber(1);
  // }, [searchQuery]);

  useEffect(() => {
    setTablesLoading(tablesListData.isLoading);
    if (
      Array.isArray(tablesListData?.data?.data) &&
      tablesListData.data.data.length > 0 &&
      !tablesListData.isLoading
    ) {
      setTables((prev) => {
        let temp = structuredClone(prev || []);
        temp = [...temp, ...tablesListData.data.data];
        temp = uniqBy(temp, (tab) => tab.id);
        return temp;
      });
      setTableRefetch(false);
    }
  }, [tablesListData.data, tablesListData.isLoading]);

  useEffect(() => {
    if (tables.length > 0 && currentPageNumber === 1) {
      setTableId(tables[0]);
    }
  }, [tables]);

  return (
    <>
      {sourceId.id.length > 0 &&
      tables.length > 0 &&
      tableId?.id &&
      (!tablesLoading || (tableRefetch && tablesLoading)) ? (
        tables.map((table, ind) => {
          return (
            <div
              className="flex flex-col w-full"
              onClick={() => {
                setTableId(table);
              }}
              key={ind}
            >
              {ind > 0 && (
                <span
                  className="w-full bg-pv-neutral-grey-100 px-2"
                  style={{
                    height: '1px',
                  }}
                ></span>
              )}
              <div
                className={`flex items-center px-4 py-3 border-l-3 border-transparent cursor-pointer hover:bg-pv-primary-primary-50 justify-between tab-el ${
                  tableId.id === table.id ? 'border-pv-primary-primary-500' : ''
                }`}
                key={ind}
              >
                <div className="flex gap-2">
                  <span
                    className={`max-w-52 ${
                      tableId.id === table.id ? `font-medium` : ``
                    }`}
                  >
                    {table.name &&
                      (table.name?.length > 25 ? (
                        <ToolTip
                          placement="top"
                          title={table.name}
                          tooltipActive={tooltipShow}
                        >
                          <span
                            onMouseEnter={() => {
                              setTooltipShow(true);
                            }}
                          >
                            {table.name.slice(0, 25) + '...'}
                          </span>
                        </ToolTip>
                      ) : (
                        <span>{table.name}</span>
                      ))}
                  </span>
                </div>
                <div className="flex gap-2">
                  {table.maps?.length > 0 && (
                    <span className="bg-pv-primary-primary-500 text-white text-1xs font-medium px-1.5 py-0.5 rounded-md">
                      {table.maps.length}
                    </span>
                  )}
                  <CaretRight />
                </div>
              </div>
            </div>
          );
        })
      ) : tables.length === 0 && !tablesLoading && !integrationsLoading ? (
        <span className="w-full text-pv-text-secondary-text text-xs">
          No Tables Found
        </span>
      ) : (
        <div className="w-full flex flex-col gap-5 p-2">
          {Array.from({ length: 10 }).map((_, index) => (
            <div className="flex gap-2 py-1" key={index}>
              <Skeleton
                variant="rounded"
                width={index % 2 === 1 ? '35%' : '65%'}
                height={20}
                sx={{ bgcolor: '#EEF0F7' }}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
